interface LogoIconProps {
  className?: string;
  strokeWidth?: number;
}

/**
 * Иконка логотипа Masters Club — три переплетённых кольца.
 *
 * `fillRule="evenodd"` обязателен: иначе один из трёх внутренних
 * кругов рендерится залитым из-за направления subpath'ов.
 */
export function LogoIcon({ className, strokeWidth = 0 }: LogoIconProps) {
  return (
    <svg
      viewBox="0 0 80.9787 74.8284"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
    >
      <path
        d="M40.5221 59.2328C38.3429 66.0367 34.2355 70.975 27.5569 73.4991C22.7127 75.3176 17.8214 75.2549 12.9771 73.405C3.31988 69.6895 -2.02607 59.2798 0.717457 49.309C2.23815 43.7436 5.60877 39.5421 10.7039 36.7986C15.7676 34.0707 21.1136 33.6318 26.7888 35.1525C21.8661 29.7752 19.6242 23.6453 20.9411 16.4495C21.8347 11.5738 24.2804 7.57614 28.1527 4.5034C36.054 -1.79887 47.279 -1.45397 54.7413 5.33429C59.0212 9.22226 61.2317 14.1449 61.3572 19.8985C61.4826 25.652 59.2407 30.559 54.9765 35.0427C61.6237 33.5691 67.3772 34.5097 72.5507 38.2095C76.6425 41.1255 79.3233 45.0762 80.4521 49.9675C82.788 60.1264 77.1598 70.2852 67.4086 73.6558C63.7244 74.9257 59.9776 75.1765 56.168 74.33C52.3741 73.4834 49.0505 71.6805 46.2599 68.9683C43.5007 66.2719 41.7449 62.9796 40.5221 59.2328ZM56.262 20.4002C56.3247 12.0285 49.5835 5.14617 41.2119 5.03642C32.7148 4.92668 25.6757 11.6993 25.5659 20.1023C25.4562 28.4739 32.3699 35.3719 40.8983 35.419C49.3484 35.466 56.1837 28.7875 56.2464 20.4002H56.262ZM45.2879 54.3414C45.1782 62.7445 51.8724 69.6425 60.2597 69.7836C68.8039 69.9247 75.8116 63.2618 75.9997 54.8431C76.1879 46.5812 69.3212 39.5421 60.9652 39.4167C52.3584 39.2756 45.382 45.9071 45.2879 54.3571V54.3414ZM35.7405 54.6863C35.8189 46.3147 29.0933 39.5107 20.6276 39.3853C12.1148 39.2756 5.06006 46.0795 5.01303 54.4512C4.966 62.7288 11.8483 69.6895 20.1886 69.8149C28.67 69.9403 35.6778 63.1207 35.7562 54.6863H35.7405ZM34.6274 39.7459C37.3866 42.7246 39.2835 46.1109 40.5377 49.9518C41.6822 46.1736 43.5948 42.9441 46.1188 39.9967C42.1995 40.8903 38.4683 40.5768 34.6274 39.7459Z"
        fill="currentColor"
        fillRule="evenodd"
        {...(strokeWidth > 0 && {
          stroke: 'currentColor',
          strokeWidth,
          strokeLinejoin: 'round' as const,
        })}
      />
    </svg>
  );
}
